import withLabel from 'components/common/form-controlled/with-label.hoc';
import AgentsSelection, { type AgentsSelectionType } from 'components/organizations/agents/agent-selection';
import withController from 'components/common/form-controlled/with-controller.hoc';

export default withLabel(withController<AgentsSelectionType>(AgentsSelection));
